const API_URL = `${import.meta.env.VITE_BASE_URL_API}/api`

const handleRequest = async (endpoint, method = "GET", data = null, headers = {}) => {
  const options = {
    method,
    headers: {
      credentials: 'include' ,
      ...headers,
    },
  };

  if (data) {
    options.body = headers['Content-Type'] === 'application/json' ? JSON.stringify(data) : data;
  }

  try {
    const response = await fetch(`${API_URL}${endpoint}`, options);
    if (response.status === 401) {
      window.location.href = `${import.meta.env.VITE_BASE_URL_API}/auth/check-login`;
    }
    if (!response.ok) {
      throw await response.json()
    }

    return response.json()
  } catch (error) {
        throw error;
  }
}

const get = async (endpoint) => {
  return handleRequest(endpoint);
}

const post = async (endpoint, data, contentType) => {
  return handleRequest(endpoint, 'POST', data, { 'Content-Type': contentType })
}

const put = async (endpoint, data) => {
  return handleRequest(endpoint, 'PUT', data, { 'Content-Type': 'application/json' })
}

const del = async (endpoint) => {
  return handleRequest(endpoint, 'DELETE')
}

export const client = {
  get,
  post,
  put,
  delete: del
}
